module.exports = __webpack_public_path__ + "img/1.e1db3c46.png";